module.exports = __webpack_public_path__ + "img/MySubscription.cd418c1b.png";